import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HelpSiteDataDTO } from '../../../common/dto/help-site.dto';

export interface AppStateModel {
  isInitialized: boolean;

  siteData?: HelpSiteDataDTO;
}

export class SetSiteDataAction {
  static readonly type = '[AppState] SetSiteDataAction';

  constructor(public siteData: HelpSiteDataDTO | undefined) {
  }
}

export const AppStateName = 'helpAppState';

export function selectAppState(store: Store): Observable<AppStateModel> {
  return store.select<AppStateModel>((state: any) => state[AppStateName]);
}

export function selectAppStateSnapshot(store: Store): AppStateModel {
  return store.selectSnapshot<AppStateModel>((state: any) => state[AppStateName]);
}

@State<AppStateModel>({
  name: AppStateName,
  defaults: {
    isInitialized: false,
    siteData: undefined,
  },
})
@Injectable()
export class AppState {
  @Selector([AppState])
  public static get(state: AppStateModel): AppStateModel {
    return state;
  }

  @Selector([AppState])
  public static siteData(state: AppStateModel): HelpSiteDataDTO | undefined {
    return state.siteData;
  }

  @Action(SetSiteDataAction)
  setSiteDataAction(ctx: StateContext<AppStateModel>, action: SetSiteDataAction) {
    ctx.patchState({
      isInitialized: true,
      siteData: action.siteData,
    });
  }
}
